import SapMaterialsForSdosList from './sapMaterialsForSdosList';

export default {
    list: SapMaterialsForSdosList,
};